import { FusaReply } from "@/types/replyTypes";
import { Client } from "./client";
import { NewVersionResponse, ProcedureAndChildrenResponse, ProcedureDuplicateRequest, ProcedureDuplicateResponse, ProcedureCreateRequest, ProcedureCreateResponse, ProcedureResponse, ProceduresResponse, ProcedureUpdateRequest } from "@/backend/express/controllers/procedureController";

export class ProcedureController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }
  
  readAll(): Promise<ProceduresResponse> {
    return this.client.read('/api/procedures');
  }

  read(id: string): Promise<ProcedureAndChildrenResponse> {
    return this.client.read(`/api/procedures/${id}`);
  }

  create(request: ProcedureCreateRequest): Promise<ProcedureCreateResponse> {
    return this.client.create('/api/procedures', request);
  }

  createNewVersion(id: string): Promise<NewVersionResponse> {
    return this.client.create(`/api/procedures/new-version/${id}`, {});
  }

  duplicate(id: string, request: ProcedureDuplicateRequest): Promise<ProcedureDuplicateResponse> {
    return this.client.create(`/api/procedures/duplicate/${id}`, request);
  }

  update(request: ProcedureUpdateRequest): Promise<ProcedureResponse> {
    return this.client.update('/api/procedures', request);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/procedures/${id}`);
  }

  updateViewedAt(id: string): Promise<FusaReply> {
    return this.client.update(`/api/procedures/viewedAt/${id}`, {});
  }
}